import { useBreadcrumb } from "core/features/breadcrumbs";
import HeaderTable from "components/Page/HeaderTable";
import { useState } from "react";
import { showErrorAxios, showSuccess, showConfirm } from "infra/helpers/alerta";
import { useLoading } from "components/GlobalLoading";
import PageHeader from "components/Page/PageHeader";
import history from "infra/helpers/history";
import {
  useDeleteFornecedor,
  useFornecedores,
  useFornecedoresColumns,
} from "features/fornecedores/hooks";
import NewTable from "components/NewTable";
import { PermissaoEnum } from "core/resources/enums/permissao";
import Container from "components/Container";
import {
  TabMenuOptions,
  TabsMenuOptionsRoutes,
} from "../Detalhes/TabsFornecedores/typings";
import { FornecedorItemResponse } from "core/features/fornecedores/typings/index";
import { PessoaTipo } from "features/pessoas/typings";

function FornecedorListagemPage() {
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(1);

  const { isLoading, isFetching, data, refetch } = useFornecedores({
    search,
    page,
  });

  const { isLoading: isLoadingDelete, mutate: handleDelete } =
    useDeleteFornecedor();

  const columns = useFornecedoresColumns({
    onToogled: () => {
      refetch();
    },
  });

  useLoading(isLoadingDelete);

  useBreadcrumb([{ name: "Administração" }, { name: "Fornecedores" }]);

  const _isLoading = isLoading || isFetching;

  return (
    <Container>
      <PageHeader
        onClick={() => history.push("/cadastros/fornecedores/novo")}
        title="Fornecedores"
        titleButton="Adicionar fornecedor"
        permissions={[PermissaoEnum.Backoffice.Administrativo.Fornecedor.Criar]}
      />

      <NewTable<FornecedorItemResponse>
        title={() => (
          <HeaderTable
            value={search}
            onSearch={(q?: string) => setSearch(q!)}
          />
        )}
        loading={_isLoading}
        columns={columns}
        dataSource={data?.items ?? []}
        actions={[
          ...TabMenuOptions.map((option) => ({
            title: option.label,
            onClick: (v: FornecedorItemResponse) => {
              history.push(
                `/cadastros/fornecedores/${v.id}?opcao=${option.route}`
              );
            },
            shouldRender: (row: FornecedorItemResponse) => {
              if (option.route === TabsMenuOptionsRoutes.Tributacao) {
                return row.pessoaTipo === PessoaTipo.Juridica;
              }
              return true;
            },
            permission: option.permission,
          })),
          {
            title: "Excluir",
            permission:
              PermissaoEnum.Backoffice.Administrativo.Fornecedor.Excluir,
            onClick: async (v) => {
              const { isConfirmed } = await showConfirm();

              if (isConfirmed) {
                handleDelete(v.id, {
                  onSuccess: () => showSuccess().then(() => refetch()),
                  onError: (err) => {
                    showErrorAxios(err);
                  },
                });
              }
            },
          },
        ]}
        customPagination={{
          currentPage: data?.meta.currentPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          onChangePage: (p) => setPage(p),
        }}
      />
    </Container>
  );
}

export default FornecedorListagemPage;
